<div id="service-case-table-component">
  <p-table #serviceCaseTable [value]="serviceCases()" [showLoader]="true" [loading]="isLoading()" dataKey="documentNo"
    [paginator]="true" [totalRecords]="totalRecords" [rows]="itemsPerPage" [rowsPerPageOptions]="[10, 25, 50]"
    [resizableColumns]="true" columnResizeMode="expand" [currentPageReportTemplate]="'primeng.currentPageReportTemplate' | translate"
    [showCurrentPageReport]="true" class="md:text-base text-sm" sortField="opened_at" [sortOrder]="-1"
    [showLoader]="false">
    <!-- Table Caption -->
    <ng-template #caption>
      <div class="grid lg:grid-cols-2 sm:grid-cols-3 grid-cols-1 md:text-base text-sm">
        <div class="col-span-1 my-auto md:mx-0 mb-3">
          <p class="font-['Apex_Rounded_Medium'] text-sm">{{ "serviceCase.myOpenCase" | translate }}</p>
        </div>
        <div class="lg:col-span-1 sm:col-span-2 col-span-1 sm:text-right text-center">
          <p-button [label]="'clearFilter' | translate" severity="danger" [outlined]="true" icon="pi pi-filter-slash"
            (click)="serviceCaseTable.clear()" styleClass="md:w-auto w-full md:text-base text-sm" />
        </div>
      </div>
    </ng-template>

    <!-- Table Header -->
    <ng-template #header let-columns>
      <tr>
        <!-- Document Number Column -->
        <th pResizableColumn pSortableColumn="number">
          {{ "serviceCase.ticketId" | translate }}
          <p-sortIcon field="number" />
          <p-columnFilter type="text" field="number" display="menu" [showOperator]="false" [showMatchModes]="false"
            [showAddButton]="false" matchMode="contains" [hideOnClear]="true">
            <ng-template #filtericon let-hasFilter="hasFilter">
              <gate-table-filter-icon [hasFilter]="hasFilter" [table]="serviceCaseTable" field="number" />
            </ng-template>
          </p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="short_description">
          {{ "serviceCase.shortDescription" | translate }}
          <p-sortIcon field="short_description" />
          <p-columnFilter type="text" field="short_description" display="menu" [showOperator]="false"
            [showMatchModes]="false" [showAddButton]="false" matchMode="contains" [hideOnClear]="true">
            <ng-template #filtericon let-hasFilter="hasFilter">
              <gate-table-filter-icon [hasFilter]="hasFilter" [table]="serviceCaseTable" field="short_description" />
            </ng-template>
          </p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="sys_created_by">
          {{ "serviceCase.createdBy" | translate }}
          <p-sortIcon field="sys_created_by" />
          <p-columnFilter type="text" field="sys_created_by" display="menu" matchMode="contains" [showOperator]="false"
            [showMatchModes]="false" [showAddButton]="false" [hideOnClear]="true">
            <ng-template #filtericon let-hasFilter="hasFilter">
              <gate-table-filter-icon [hasFilter]="hasFilter" [table]="serviceCaseTable" field="sys_created_by" />
            </ng-template>
          </p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="u_affected_user">
          {{ "serviceCase.affectedPerson" | translate }}
          <p-sortIcon field="u_affected_user" />
          <p-columnFilter type="text" field="u_affected_user" display="menu" matchMode="contains" [showOperator]="false"
            [showMatchModes]="false" [showAddButton]="false" [hideOnClear]="true">
            <ng-template #filtericon let-hasFilter="hasFilter">
              <gate-table-filter-icon [hasFilter]="hasFilter" [table]="serviceCaseTable" field="u_affected_user" />
            </ng-template>
          </p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="opened_at">
          {{ "serviceCase.openedOn" | translate }}
          <p-sortIcon field="opened_at" />
        </th>
        <th pResizableColumn pSortableColumn="sysUpdatedOn">
          {{ "serviceCase.updatedOn" | translate }}
          <p-sortIcon field="sysUpdatedOn" />
        </th>
        <th pResizableColumn pSortableColumn="state">
          {{ "serviceCase.statusLabel" | translate }}
          <p-columnFilter field="state" matchMode="equals" display="menu" [showOperator]="false"
            [showMatchModes]="false" [showAddButton]="false" [hideOnClear]="true">
            <ng-template #filtericon let-hasFilter="hasFilter">
              <gate-table-filter-icon [hasFilter]="hasFilter" [table]="serviceCaseTable" field="state" [options]="serviceCaseStatuses" />
            </ng-template>
            <ng-template #filter let-value let-filter="filterCallback">
              <p-select [ngModel]="value" [options]="serviceCaseStatuses" (onChange)="filter($event.value)"
                optionLabel="key" optionValue="value" [placeholder]="'selectStatus' | translate">
              </p-select>
            </ng-template>
          </p-columnFilter>
          <p-sortIcon field="state" />
        </th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template #body let-serviceCase let-columns="columns">
      <tr>
        <!-- Document Number Data -->
        <td>
          <span class="p-column-title">{{ "serviceCase.ticketId" | translate }}</span><span>{{ serviceCase.number
            }}</span>
        </td>
        <!-- Reference Data -->
        <td>
          <span class="p-column-title">{{ "serviceCase.shortDescription" | translate }}</span><span
            class="truncate hover:text-clip" [title]="serviceCase.short_description">{{ serviceCase.short_description
            }}</span>
        </td>
        <!-- Document Date Data formatted as dd.MM.yyyy -->
        <td>
          <span class="p-column-title">{{ "serviceCase.createdBy" | translate }}</span><span>{{
            serviceCase.sys_created_by ?? "-" }}</span>
        </td>
        <td>
          <span class="p-column-title">{{ "serviceCase.affectedPerson" | translate }}</span><span>{{
            serviceCase?.u_affected_user?.display_value ?? "-" }}</span>
        </td>
        <!-- Status Data with Severity Tag -->
        <td>
          <span class="p-column-title">{{ "serviceCase.openedOn" | translate }}</span>{{ serviceCase.openedAt ?
          (serviceCase.openedAt | date: "dd.MM.yyyy") : "-" }}
        </td>
        <td>
          <span class="p-column-title">{{ "serviceCase.updatedOn" | translate }}</span>{{ serviceCase.sysUpdatedOn ?
          (serviceCase.sysUpdatedOn | date: "dd.MM.yyyy") : "-" }}
        </td>
        <td>
          <span class="p-column-title">{{ "serviceCase.statusLabel" | translate }}</span>
          <span><p-tag [value]="serviceCase.state | ServiceCaseStatus | translate" [severity]="getSeverity(serviceCase.state)" [ngStyle]="{ 'left.px': 5, 'top.px': 5 }" /></span>
        </td>
      </tr>
    </ng-template>

    <!-- Custom Empty Message Template -->
    <ng-template #emptymessage>
      <tr class="emptymessage">
        <td colspan="7">
          <div class="text-center">
            <i class="pi pi-exclamation-triangle text-yellow-500" style="font-size: 2rem"></i>
            <p>{{ "serviceCase.emptyTooltip" | translate }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #loadingbody>
      @for (i of [1,2,3,4,5]; track i) {
      <tr class="skeleton-row">
        <td><p-skeleton width="50%" height="1rem"></p-skeleton>
        </td>
        <td class="block md:table-cell py-2">
          <p-skeleton class="md:w-[65%] w-full" height="1rem"></p-skeleton>
        </td>
        <td class="block md:table-cell py-2">
          <p-skeleton class="md:w-[60%] w-full" height="1rem"></p-skeleton>
        </td>

        <td class="block md:table-cell py-2">
          <p-skeleton class="md:w-[60%] w-full" height="1rem"></p-skeleton>
        </td>

        <td class="block md:table-cell py-2">
          <p-skeleton class="md:w-[60%] w-full" height="1rem"></p-skeleton>
        </td>
        <td class="block md:table-cell py-2">
          <p-skeleton class="md:w-[70%] w-full" height="1rem"></p-skeleton>
        </td>
        <td class="block md:table-cell py-2">
          <p-skeleton class="md:w-[65%] w-full" height="1rem"></p-skeleton>
        </td>
      </tr>
      }
    </ng-template>

  </p-table>
</div>
